import React, { Component } from 'react';

import api from '../../../../api/';
import ParadigmaTable from "../../../../components/ParadigmaTable/";

import Modal from './Modal';

class Tarjetas extends Component {
    constructor() {
        super();
        this.state = {
            columns: [
                {
                    Header: "id",
                    id: "id",
                    accessor: "id",
                    show: false,
                    private: true,
                },
                {
                    Header: "Nombre",
                    id: "Nombre",
                    accessor: "Nombre",
                    show: true,
                },
                {
                    Header: "Ligado a Condición de Pago",
                    id: "NombreCondicionDePago",
                    accessor: "NombreCondicionDePago",
                    show: true,
                },
            ],
        };
    }

    render() {
        const { modernTheme } = this.props;
        return (
            <ParadigmaTable
                modernTheme={modernTheme}
                buttons={[
                    {
                        create: true,
                        component: (props) => <Modal {...props} action="CREATE" />,
                        // permission: 'usuarios_grupos_new',
                    },
                    {
                        edit: true,
                        component: (props) => <Modal {...props} action="EDIT" />,
                        // permission: 'usuarios_grupos_edit',
                    },
                    {
                        edit: true,
                        component: (props) => <Modal {...props} action="DETAIL" />,
                        // permission: 'usuarios_grupos_detail',
                    },
                    {
                        delete: true,
                        component: (props) => <Modal {...props} action="DELETE" />,
                        // permission: 'usuarios_grupos_delete',
                    }
                ]}
                apiUrl={api.gestion.ventas.tarjetas}
                columns={this.state.columns}
                title={"Tarjetas"}
            />
        );
    }
}

export default Tarjetas;



// WEBPACK FOOTER //
// ./src/views/Gestion/Ventas/Tarjetas/Tarjetas.js